import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./protected";
import React from "react";
import { SidebarProvider } from "../context/sidebar";

const Layout = React.lazy(() => import("../layouts"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Forms = React.lazy(() => import("../pages/forms"));
const JobOpeningPage = React.lazy(() => import("../pages/jobOpenings"));
const JobOpeningCreatePage = React.lazy(() => import("../pages/jobOpenings/create"));
const JobOpeningEditPage = React.lazy(() => import("../pages/jobOpenings/edit/page"));
const AnggaranPage = React.lazy(() => import("../pages/anggaran"));
const AnggaranCreatePage = React.lazy(() => import("../pages/anggaran/create/page"));
const AnggaranEditPage = React.lazy(() => import("../pages/anggaran/edit/page"));
const KodeAkunPage = React.lazy(() => import("../pages/configuration/account-codes/page"));
const PosAnggaranPage = React.lazy(() => import("../pages/configuration/budget-posts"));
const WorkflowPage = React.lazy(() => import("../pages/configuration/workflow"));
const Login = React.lazy(() => import("../pages/login"));
const Auth = React.lazy(() => import("../pages/auth"));
const NotFound = React.lazy(() => import("../pages/404"));

const MainRouter = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute
        element={
          <SidebarProvider>
            <Layout />
          </SidebarProvider>
        }
      />
    ),
    children: [
      { index: true, element: <Dashboard />, handle: { name: "Beranda" } },
      { path: "forms", element: <Forms />, handle: { name: "Formulir" } },
      {
        path: "lowongan-kerja",
        handle: { name: "Lowongan Kerja" },
        children: [
          {
            index: true,
            element: <JobOpeningPage />,
            handle: { name: "Daftar" },
          },
          {
            path: "buat",
            element: <JobOpeningCreatePage />,
            handle: { name: "Buat" },
          },
          {
            path: "edit/:id",
            element: <JobOpeningEditPage />,
            handle: { name: "Edit" },
          }
        ]
      },
      {
        path: "anggaran",
        handle: { name: "Anggaran" },
        children: [
          {
            index: true,
            element: <AnggaranPage />,
            handle: { name: "Daftar" },
          },
          {
            path: "buat",
            element: <AnggaranCreatePage />,
            handle: { name: "Buat" },
          },
          {
            path: "edit/:id",
            element: <AnggaranEditPage />,
            handle: { name: "Edit" },
          }
        ]
      },
      {
        path: "master",
        handle: { name: "Master" },
        children: [
          {
            path: "kode-akun",
            element: <KodeAkunPage />,
            handle: { name: "Kode Akun" }
          },
          {
            path: "pos-anggaran",
            element: <PosAnggaranPage />,
            handle: { name: "Pos Keuangan" }
          },
          {
            path: "workflow",
            element: <WorkflowPage />,
            handle: { name: "Workflow" }
          }
        ]
      },
    ],
  },
  { path: "/login", element: <Login />, handle: { name: "Login" } },
  { path: "/auth", element: <Auth />, handle: { name:"Auth" }},
  { path: "*", element:<NotFound />, handle: { name: "NotFound"}},
]);

export default MainRouter;
